import { Invite } from 'src/interfaces/invite'
import { State } from '../reducers/types'

export const getInvite = (state: State): Invite | null => state.invite.invite
